import React, { CSSProperties, useState } from 'react'
import { FilterDescriptor } from '@progress/kendo-data-query'
import { SelectValue } from 'antd/es/select'
import { Option, Select } from 'components/Select'

interface YesNoFilterProps {
  placeholder?: string
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
  style?: CSSProperties
}

export const YesNoFilter: React.FC<YesNoFilterProps> = ({
  placeholder,
  filter,
  onFilterChange,
  ...props
}) => {
  const [selectedData, setSelectedData] = useState<SelectValue>([])
  const selectValue = filter.value ?? selectedData

  return (
    <Select
      style={{ width: 80 }}
      {...props}
      placeholder={placeholder}
      value={selectValue}
      onChange={(value: SelectValue) => {
        const dataValue = value || []
        setSelectedData(dataValue)
        onFilterChange.call(undefined, {
          nextFilter: { ...filter, value: dataValue },
        })
      }}
      allowClear
      showSearch
    >
      <Option value='true'>Yes</Option>
      <Option value='false'>No</Option>
    </Select>
  )
}
